import { useCallback } from 'react';
import type { ImpactGroup } from '@locus-taxy/entity-detail';
import { buildDependentGridPath } from '../utils/dependentGridPath';
import { useClientId } from './useClientId';
import { useDashboardHref } from './useDashboardNavigate';

/**
 * "View in grid" on an impact-preview group (DP-8309, DP-8964): opens the
 * dependent entity's grid narrowed to the group's records, in a new tab so the
 * action dialog stays open. The entity-detail framework and encore-grid own no
 * router, so they hand the group back and the dashboard builds the in-app
 * href. Shared by the detail page and the grid page so both open the same URL.
 */
export function useOpenDependentGrid(): (
  group: Pick<ImpactGroup, 'targetEntity' | 'condition'>
) => void {
  const clientId = useClientId();
  const toDashboardHref = useDashboardHref();
  return useCallback(
    group => {
      const path = buildDependentGridPath(group, clientId);
      if (path) {
        window.open(toDashboardHref(path), '_blank', 'noopener');
      }
    },
    [toDashboardHref, clientId]
  );
}
